import styled from "styled-components";

interface SkinProps {
  $isGriffle?: boolean;
}

interface BadgeContainerProps extends SkinProps {
  $color: string;
  $size: "sm" | "md";
}

export const BadgeContainer = styled.span<BadgeContainerProps>`
  display: inline-flex;
  align-items: center;
  gap: ${({ $size }) => ($size === "sm" ? "4px" : "6px")};
  padding: ${({ $size }) => ($size === "sm" ? "2px 8px" : "4px 10px")};
  border-radius: 12px;
  background-color: ${({ $color }) => `${$color}18`};
  font-size: ${({ $size }) => ($size === "sm" ? "11px" : "13px")};
  font-weight: 600;
  color: ${({ $color }) => $color};
  line-height: 1.4;
  white-space: nowrap;
  font-family: ${({ $isGriffle }) =>
    $isGriffle ? "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" : "inherit"};
`;

export const Dot = styled.span<{ $color: string }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
  flex-shrink: 0;
`;
